'use client';
import React, { useRef } from 'react';
import cx from 'classnames';
import { InfoBox } from '@THC/components/InfoBox';
import { useToast } from './useToast';
import styles from '../Toast.shared.module.scss';
export const Toast = (props) => {
    const toastRef = useRef(null);
    const { infoBoxProps, properties, toastProps } = useToast(props, { toastRef });
    const { content, heading, ...restInfoBoxProps } = infoBoxProps;
    const hasOnlyContent = !heading && content;
    return (<li ref={toastRef} className={cx(styles.toast, {
            [styles.static]: properties.isToastStatic,
            [styles.mounted]: properties.isToastMounted,
        })} {...toastProps}>
			<div className={styles.toastContainer}>
				<InfoBox content={content ? (<div className={cx({
                [styles.toastContextNoHeading]: hasOnlyContent,
            })}>
								{content}
							</div>) : undefined} heading={heading ? <div className={styles.toastHeading}>{heading}</div> : undefined} {...restInfoBoxProps}/>
			</div>
		</li>);
};
